import { PageInstance } from '@tarojs/runtime'

export const stacks: PageInstance[] = []
